import { Route } from "react-router-dom";
import { EditAssignment, FeedbackAssignment } from "../Assignments/EditAssignment";
import { AssignmentList } from "../Assignments/Table/AssignmentList";

export const ASSIGNMENT_ROUTES = [
    <Route key="assignments" path="/assignments" element={<AssignmentList />} />,
    <Route key="assignments-update" path="/assignments/update_assignment/:id" element={<EditAssignment />} />,
    <Route key="assignments-feedback" path="/assignments/feedback" element={<FeedbackAssignment />} />
];
